import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { checkEmailBlackList } from '../../Email.api'
import {
  EMAIL_CREATION_FORM_BLACK_LIST_API_PARAM,
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_NOTIFICATION_BLACK_LIST_CHECK_SERVER_ERROR,
  EMAIL_CREATION_FORM_NOTIFICATION_HAS_BLACK_LIST_ACCOUNTS,
} from '../EmailCreationForm.constants'
import {
  filterEmailFormBlackListAccounts,
  getEmailFormAccountsListForBlackListVerification,
} from '../EmailCreationForm.utils'

export function useAccountsBlackList({
  accountId,
  blackList,
  removeNotification,
  setBlackList,
  setNotification,
}) {
  const { t } = useTranslation()

  const { handleSubmit, setFieldValue, setSubmitting, values } =
    useFormikContext()

  const accounts = getEmailFormAccountsListForBlackListVerification(
    values,
    values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
  )

  useEffect(() => {
    if (blackList.length > 0) {
      setBlackList(val => val.filter(i => accounts.includes(i)))
    }
  }, [accounts])

  useEffect(() => {
    if (blackList.length === 0) {
      removeNotification(
        EMAIL_CREATION_FORM_NOTIFICATION_HAS_BLACK_LIST_ACCOUNTS
      )
    }
  }, [blackList])

  function handleDeleteBlackListUsers(blackList) {
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_TO,
      filterEmailFormBlackListAccounts(
        values[EMAIL_CREATION_FORM_FIELD_NAME_TO],
        blackList,
        values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
      )
    )
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_CC,
      filterEmailFormBlackListAccounts(
        values[EMAIL_CREATION_FORM_FIELD_NAME_CC],
        blackList,
        values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
      )
    )
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_BCC,
      filterEmailFormBlackListAccounts(
        values[EMAIL_CREATION_FORM_FIELD_NAME_BCC],
        blackList,
        values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
      )
    )

    removeNotification(EMAIL_CREATION_FORM_NOTIFICATION_HAS_BLACK_LIST_ACCOUNTS)
  }

  function handleCheckBlackList() {
    removeNotification(
      EMAIL_CREATION_FORM_NOTIFICATION_BLACK_LIST_CHECK_SERVER_ERROR
    )

    if (accounts.length > 0) {
      checkEmailBlackList({
        [EMAIL_CREATION_FORM_BLACK_LIST_API_PARAM]: accounts,
        account: accountId,
      })
        .then(({ data }) => {
          if (data.length > 0) {
            setBlackList(data)
            setSubmitting(false)
            setNotification({
              id: EMAIL_CREATION_FORM_NOTIFICATION_HAS_BLACK_LIST_ACCOUNTS,
              linkProps: {
                Component: 'span',
                title: t('Email.DeleteBlackListUsersKey'),
                onClick: () => handleDeleteBlackListUsers(data),
              },
              text: t('Form.BlackListedUsersErrorKey'),
              type: NOTIFICATION_TYPE.error,
            })
          } else {
            handleSubmit()
          }
        })
        .catch(() => {
          setSubmitting(false)

          setNotification({
            id: EMAIL_CREATION_FORM_NOTIFICATION_BLACK_LIST_CHECK_SERVER_ERROR,
            text: t('Form.BlackListCheckServerErrorKey'),
            type: NOTIFICATION_TYPE.error,
          })
        })
    } else {
      handleSubmit()
    }
  }

  return { blackList, handleCheckBlackList }
}
